import { AppIconTypes } from "src/components/AppIcons/interface";
import extractSingleValueFromArrayOfObject from "src/utils/extractSingleValueFromArrayOfObject";
import { IMenu, IMenuChild } from "./interface";

/**
 * IMPORTANTE:
 * efb001Codigo tem que estar em ingles !!
 */
const permissionsMenu : IMenu[] = [
	{
		efb005Descricao: "Diagnóstico de Negócio",
		efb005DescricaoSimplificada: "Diagnósticos",
		efb001Codigo: "businessdiagnostics",
		img: "businessDiagnosis" as AppIconTypes,			
		children: [{
			efb005Descricao: "Modelos de diagnóstico de negócio",
			efb001Codigo: "diagnosticmodels"			
		},{
			efb005Descricao: "Diagnósticos de negócio",
			efb001Codigo: "diagnostics"			
		},
		{
			efb005Descricao: "Canvas",
			efb001Codigo: "canvas"				
		}]
	},{
		efb005Descricao: "Análises",
		efb001Codigo: "analysis",
		img: "analysis" as AppIconTypes,			
		children: [{
			efb005Descricao: "SWOT",
			efb001Codigo: "analysis/swot"
		},{
			efb005Descricao: "Análises",
			efb001Codigo: "analysis/panel"
		},{
			efb005Descricao: "Market Share",
			efb001Codigo: "analysis/marketshare"
		},{
			efb005Descricao: "Matriz BCG",
			efb001Codigo: "analysis/matrizbcg"
		},{
			efb005Descricao: "Dimensões",
			efb001Codigo: "analysis/dimensions",
			putSeparatorBeforeSidebarItem: true	
		},{
			efb005Descricao: "Estratégias SWOT",
			efb001Codigo: "analysis/swotstrategy",
			internalAction: true
		},{
			efb005Descricao: "Concorrentes",
			efb001Codigo: "analysis/competitors"
		},{
			efb005Descricao: "Itens BCG",
			efb001Codigo: "analysis/bcgitems"
		}]
	},{
		efb005Descricao: "Planejamento Estratégico",
		efb005DescricaoSimplificada: "Planejamento",
		efb001Codigo: "strategicPlanning",
		img: "strategicPlanning" as AppIconTypes, 
		children: [
			{
				efb005Descricao: "Mapa BSC",
				efb001Codigo: "maps/panel"
			},
			{
				efb005Descricao: "Objetivos x Indicadores",
				efb001Codigo: "maps/hierarchy"
			},
			{
				efb005Descricao: "OKR's",
				efb001Codigo: "okr/panel"
			},
			{
				efb005Descricao: "Estratégias",
				efb001Codigo: "strategies/panel"
			}
		]
	},{
		efb005Descricao: "Projetos",
		efb001Codigo: "projects",
		
		img: "projects" as AppIconTypes,			
		children: [{
			efb005Descricao: "Painel de projetos",
			efb001Codigo: "projects/panel"
		}]
	},{
		efb005Descricao: "Gestão Orçamentária",
		efb005DescricaoSimplificada: "Orçamentos",
		efb001Codigo: "financialManagement",
		img: "financialManagement" as AppIconTypes,
		children: [{
			efb005Descricao: "Planos orçamentários",
			efb001Codigo: "financialmanagement/panel"
		}
		// ,{
		// 	efb005Descricao: "Valores contábeis",
		// 	efb001Codigo: "financialmanagement/accounting"
		// }
		]
	},
	{
		efb005Descricao: "Indicadores",
		efb001Codigo: "indicators",		
		img: "indicators" as AppIconTypes,
		children: [
			{
				efb005Descricao: "Painel de indicadores",
				efb001Codigo: "indicators/panel"	
			},
			{
				efb005Descricao: "Painel de apresentação",
				efb001Codigo: "indicators/presentation"
			},
			{
				efb005Descricao: "Hierarquia de indicadores",
				efb001Codigo: "indicators/hierarchy"	
			},
			{
				efb005Descricao: "Importação manual",
				efb001Codigo: "indicators/valuesimport"
			},
			{
				efb005Descricao: "Indicadores",
				efb001Codigo: "indicators",
				putSeparatorBeforeSidebarItem: true	
			},
			{
				efb005Descricao: "Campos de indicador",
				efb001Codigo: "indicators/fields"	
			},
			{
				efb005Descricao: "Grupos de apresentação",
				efb001Codigo: "indicators/presentationgroups"
			}
		]
	},{
		efb005Descricao: "Ações",
		efb001Codigo: "actions",
		img: "actions" as AppIconTypes,			
		children: [{
			efb005Descricao: "Painel de ações",
			efb001Codigo: "actions/panel"
		},{
			efb005Descricao: "Matriz de priorização",
			efb001Codigo: "actions/matrix"
		},{
			efb005Descricao: "Kanban",
			efb001Codigo: "actions/kanban"
		}]
	},{
		efb005Descricao: "Riscos",
		efb001Codigo: "risks",
		
		img: "risks" as AppIconTypes,			
		children: [
			{
				efb005Descricao: "Painel de riscos",
				efb001Codigo: "risks/panel"			
			},
			{
				efb005Descricao: "Matriz de riscos",
				efb001Codigo: "risks/matrix"				
			},{
				efb005Descricao: "Classificação de riscos",
				efb001Codigo: "risks/classification",
				putSeparatorBeforeSidebarItem: true				
			}
		]
	},{
		efb005Descricao: "Ocorrências",
		efb001Codigo: "occurrences",
		img: "occurrences" as AppIconTypes,			
		children: [
			{
				efb005Descricao: "Painel de ocorrências",
				efb001Codigo: "occurrences/panel"			
			},
			{
				efb005Descricao: "Categorias de ocorrências",
				efb001Codigo: "occurrences/categories",
				putSeparatorBeforeSidebarItem: true				
			},
			{
				efb005Descricao: "Requisitos de ocorrências",
				efb001Codigo: "occurrences/requirements"			
			},
			{
				efb005Descricao: "Origens de ocorrências",
				efb001Codigo: "occurrences/origins"			
			},
			{
				efb005Descricao: "Etapas padrões de ocorrências",
				efb001Codigo: "occurrences/standardsteps",
				internalAction: true			
			}
		]
	},{
		efb005Descricao: "Auditorias",
		efb001Codigo: "audits",
		img: "audits" as AppIconTypes,			
		children: [{
			efb005Descricao: "Painel de auditorias",
			efb001Codigo: "audit/panel"
		},{
			efb005Descricao: "Normas de auditorias",
			efb001Codigo: "audit/standards",
			putSeparatorBeforeSidebarItem: true	
		}]
	},{
		efb005Descricao: "Reuniões",
		efb001Codigo: "meetings",
		img: "meeting" as AppIconTypes,			
		children: [
			{
				efb005Descricao: "Painel de reuniões",
				efb001Codigo: "meeting/panel"			
			},{
				efb005Descricao: "Salas de reunião",
				efb001Codigo: "meeting/rooms",
				putSeparatorBeforeSidebarItem: true			
			},{
				efb005Descricao: "Tipos de reunião",
				efb001Codigo: "meeting/types"			
			}]
	},{
		efb005Descricao: "Cadastros Básicos",
		efb005DescricaoSimplificada: "Cadastros",
		efb001Codigo: "configs" ,		
		img: "configs" as AppIconTypes,			
		children: [{
			efb005Descricao: "Setores",
			efb001Codigo: "sectors"
		},{
			efb005Descricao: "Classificações",
			efb001Codigo: "classifications"
		},{
			efb005Descricao: "Processos",
			efb001Codigo: "process"			
		},{
			efb005Descricao: "Unidades de medida",
			efb001Codigo: "measureunits"			
		},{
			efb005Descricao: "Tipos de período",
			efb001Codigo: "periodtypes"			
		},{
			efb005Descricao: "Modelos de canvas",
			efb001Codigo: "canvasmodels",
			internalAction: true			
		},{
			efb005Descricao: "Tags",
			efb001Codigo: "tags"			
		},{
			efb005Descricao: "Métricas",
			efb001Codigo: "metrics"			
		},{
			efb005Descricao: "Moedas",
			efb001Codigo: "coins"			
		}]
	},{
		efb005Descricao: "Relatórios",
		efb001Codigo: "reports",
		img: "reports" as AppIconTypes,			
		children: [
			{
				efb005Descricao: "Visualizar relatórios",
				efb001Codigo: "reports/panel"			
			},{
				efb005Descricao: "Gerênciar relatórios",
				efb001Codigo: "reports",
				internalAction: true,
				putSeparatorBeforeSidebarItem: true				
			}]
	},{
		efb005Descricao: "Configurações do sistema",
		efb001Codigo: "systemConfigs",		
		icon: "settings",
		children: [{
			efb005Descricao: "Usuários",
			efb001Codigo: "users",
			icon: "user",
			systemConfigs: true
		},{
			efb005Descricao: "Grupos de usuários",
			efb001Codigo: "usergroup",
			icon: "users",
			systemConfigs: true
		},{
			efb005Descricao: "Empresa",
			efb001Codigo: "business",
			icon: "building",
			systemConfigs: true
		},{
			efb005Descricao: "Grupo empresarial",
			efb001Codigo: "businessgroup",
			icon: "building",
			internalAction: true,
			systemConfigs: true
		},{
			efb005Descricao: "Permissões",
			efb001Codigo: "permissions",
			icon: "hierarchy",
			systemConfigs: true
		},{
			efb005Descricao: "Itens de Contrato",
			efb001Codigo: "contractitems",
			icon: "document",
			systemConfigs: true,
			internalAction: true
		},{
			efb005Descricao: "Monitorar contratos",
			efb001Codigo: "monitorcontracts",
			icon: "graphUp",
			systemConfigs: true,
			internalAction: true
		},{
			efb005Descricao: "Planos comerciais",
			efb001Codigo: "commercialplans",
			icon: "document",
			systemConfigs: true,
			internalAction: true
		},{
			efb005Descricao: "Notificações",
			efb001Codigo: "notifications",
			icon: "bell",
			internalAction: true,
			systemConfigs: true
		},{
			efb005Descricao: "Origem de dados",
			efb001Codigo: "dataorigin",
			icon: "database", 
			systemConfigs: true
		},{
			efb005Descricao: "Tipos de Integração",
			efb001Codigo: "integrationtypes",
			internalAction: true,
			icon: "refresh", 
			systemConfigs: true
		},{
			efb005Descricao: "Integrações",
			efb001Codigo: "integrations",
			icon: "refresh", 
			systemConfigs: true
		},{
			efb005Descricao: "Chaves de acesso externo",
			efb001Codigo: "externalaccesskeys",
			icon: "key", 
			systemConfigs: true
		},{
			efb005Descricao: "Configurar IP's de acesso",
			efb001Codigo: "accessIp",
			icon: "world", 
			systemConfigs: true
		},{
			efb005Descricao: "Domínios",
			efb001Codigo: "domains",
			icon: "domain", 
			systemConfigs: true
		},{
			efb005Descricao: "Conexões do sistema",
			efb001Codigo: "systemconnections",
			icon: "cloud",
			systemConfigs: true
		},{
			efb005Descricao: "Lixeira",
			efb001Codigo: "trash",
			icon: "trash",
			systemConfigs: true
		},{
			efb005Descricao: "Configurar parâmetros",
			efb001Codigo: "parameters/groups",
			icon: "settings",	
			internalAction: true			
		},
		{
			efb005Descricao: "Hierarquia de parâmetros",
			efb001Codigo: "parameters/hierarchy",
			icon:"hierarchy",
			systemConfigs:true			
		},{
			efb005Descricao: "Incidentes",
			efb001Codigo: "incidents",
			icon: "exclamation",
			systemConfigs: true,
			internalAction: true
		},{
			efb005Descricao: "Termos de uso",
			efb001Codigo: "termsuse",
			icon: "list",
			systemConfigs: true,
			internalAction: true
		}]	
	}];

export const lastLevelPermissionsPathWithoutSystemConfigs = permissionsMenu.filter((x) => x.efb001Codigo !== "systemConfigs").map((x) => extractSingleValueFromArrayOfObject("efb001Codigo", x.children)).flat();

export const lastLevelPermissionsMenuSystemConfigs: IMenuChild[] = permissionsMenu.filter((x) => x.efb001Codigo === "systemConfigs")[0]?.children ?? [];

export const lastLevelInternalActionsPermissionsMenu: IMenuChild[] = permissionsMenu.map((x) => x.children).flat().filter((x) => x && x.internalAction);

/**
 * IMPORTANTE:
 * efb001Codigo tem que estar em ingles !!
 */
export default permissionsMenu;
